<template>
  <table class="v-table-key-value">
    <thead v-if="headerKey && headerValue">
      <tr>
        <th>{{ headerKey }}</th>
        <th>{{ headerValue }}</th>
      </tr>
    </thead>
    <slot />
  </table>
</template>

<script setup lang="ts">
import { provide } from 'vue'

import { $tableKeyValueKey } from '../../utils/injections.ts'

export interface Props {
  keyWidth?: string
  valueWidth?: string
  headerKey?: string
  headerValue?: string
}

const props = withDefaults(defineProps<Props>(), {
  keyWidth: '',
  valueWidth: '',
  headerKey: '',
  headerValue: '',
})

defineSlots<{
  default?(): any
}>()

provide($tableKeyValueKey, props)
</script>

<style>
.v-table-key-value {
  width: 100%;
  border-spacing: 0;

  th {
    text-align: left;
    padding: 15px 0;
    font-weight: 500;
  }
}
</style>
